import { render, staticRenderFns } from "./ChooseUniversity.html?vue&type=template&id=b267c8c2&scoped=true&external"
import script from "./ChooseUniversity.vue?vue&type=script&lang=js"
export * from "./ChooseUniversity.vue?vue&type=script&lang=js"
import style0 from "./ChooseUniversity.scss?vue&type=style&index=0&id=b267c8c2&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b267c8c2",
  null
  
)

export default component.exports